// extracted by mini-css-extract-plugin
export default {"subtitle":"u_70lv"};